import type { TFunction } from 'i18next'
import type { Task } from '@/src/renderer/lib/db/models'
import { showSuccessToast } from '@/src/renderer/components/common/SuccessToast'
import { dispatchAppEvent } from '@/src/renderer/lib/events'

/**
 * „In Steuer angelegt · Anzeigen“ (#234) — die neue Aufgabe steht nicht in der Liste, in der getippt
 * wurde; beim Bearbeiten „Nach Steuer verschoben“. „Anzeigen“ springt hin wie ein Treffer der Suche
 * (`MainLayout`, Ereignis `open-task`).
 */
export function showCreatedElsewhereToast(t: TFunction, place: string, task: Task, kind: 'created' | 'moved' = 'created'): void {
  showSuccessToast({
    message: t(kind === 'moved' ? 'titleRecognition.movedTo' : 'titleRecognition.createdIn', { place }),
    action: { label: t('common.show'), onClick: () => dispatchAppEvent('open-task', { task }) },
  })
}
